import React from 'react'
import { connect } from 'react-redux'
import Popup from 'reactjs-popup'
import rp from 'request-promise-native'
import { uri, uriV2, supportPhone, privacyPolicyURL } from './defaultProps'
import ShaJs from 'sha.js'
import sendMessageWPP from './sendMessageWPP'
import Loader from 'react-loader-spinner'
import * as actions from '../redux/actions'

const styles = {
  popupContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '8px'
  },
  popupHeader: {
    margin: '0',
    textAlign: 'center',
    color: '#6c367a'
  },
  popupParagraph: {
    textAlign: 'center'
  },
  popupDivisor: {
    width: '100%',
    margin: '8px',
    backgroundColor: '#a2a2a2',
    height: '1px'
  },
  popupLink: {
    textDecoration: 'underline'
  },
  popupButtonsSection: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  popupAcceptButton: {
    backgroundColor: '#1f8408',
    color: '#ffffff',
    cursor: 'pointer',
    width: '50%',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '8px',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    paddingTop: '8px',
    paddingBottom: '8px',
    fontWeight: 'bold'
  },
  popupRejectButton: {
    backgroundColor: '#d02020',
    color: '#ffffff',
    cursor: 'pointer',
    width: '50%',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '8px',
    boxShadow: 'rgba(32, 3, 61, 0.55) 0px 4px 4px',
    paddingTop: '8px',
    paddingBottom: '8px',
    fontWeight: 'bold'
  },
  popupContentStyle: {
    maxWidth: '768px',
    width: '100%',
    borderRadius: '16px',
    margin: 'auto'
  },
  popupOverlayStyle: {
    padding: '16px'
  }

}

class TermsHandler extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPopup: false,
      privacyPolicyUpstreamVersion: undefined,
      loading: false
    }
  }

  componentDidMount () {
    // Checks when you are already logged in
    if (this.props.token && this.props.user) {
      this.showsPopupIfItIsAnOldVersionOfTheTerm()
    }
  }

  componentDidUpdate (prevProps) {
    if (
      (!prevProps.token && this.props.token) ||
      (this.props.user &&
        prevProps.user &&
        prevProps.user.privacyPolicyVersion !==
          this.props.user.privacyPolicyVersion)
    ) {
      this.showsPopupIfItIsAnOldVersionOfTheTerm()
    }
  }

  getTermVersionFromApi = async () => {
    const privacyPolicyPage = await rp(`${privacyPolicyURL}`)

    const shaOfPrivacyPolicy = ShaJs('sha256')
      .update(privacyPolicyPage)
      .digest('hex')

    const privacyPolicyUpstreamVersion = `${shaOfPrivacyPolicy}`
    this.setState({ privacyPolicyUpstreamVersion })
    return privacyPolicyUpstreamVersion
  }

  showsPopupIfItIsAnOldVersionOfTheTerm = async () => {
    try {
      const termVersionFromApi = await this.getTermVersionFromApi()

      const areDifferentVersions =
        this.props.user.privacyPolicyVersion !== termVersionFromApi
      if (areDifferentVersions) {
        this.openPopup()
      }
    } catch (err) {
      console.error(err)
    }
  }

  acceptChanges = async () => {
    this.setState({loading: true})
    try {
      await rp({
        uri: `${uriV2}/user/privacyPolicy`,
        method: 'PATCH',
        headers: {
          Authorization: this.props.token
        },
        body: {
          privacyPolicyVersion: this.state.privacyPolicyUpstreamVersion
        },
        json: true
      })
      const user = await rp({
        uri: `${uri}/user`,
        method: 'GET',
        headers: {
          Authorization: this.props.token
        },
        json: true
      })
      this.props.setUser(user)
      this.setState({showPopup: false})
    } catch (err) {
      console.error('Erro ao aceitar a política de privacidade: ', err)
    } finally {
      this.setState({loading: false})
    }
  }

  openPopup = () => this.setState({showPopup: true})

  renderLoader = () => {
    return (
      <div style={styles.popupContentContainer}>
        <Loader
          type='TailSpin'
          color='#6d357b'
          height='50'
          width='50'
        />
      </div>
    )
  }

  renderPopupContent = () => {
    return (
      <div style={styles.popupContentContainer}>
        <h2 style={styles.popupHeader}>
          Aceita as mudanças nas políticas de privacidade?
        </h2>
        <div style={styles.popupDivisor} />
        <p style={styles.popupParagraph}>
          Ocorreram mudanças nas políticas de privacidade.
        </p>
        <p style={styles.popupParagraph}>
          Acesse a {' '}
          <a href={privacyPolicyURL} target='_blank'
            style={styles.popupLink}>Política de Privacidade</a>
          {' '} e saiba mais.
        </p>
        <div style={styles.popupDivisor} />
        <div style={styles.popupButtonsSection}>
          <div style={styles.popupAcceptButton}
            onClick={() => this.acceptChanges()}
          >
            Aceito
          </div>
          <div style={styles.popupRejectButton}
            onClick={() => sendMessageWPP(supportPhone, `Olá, sou cliente Mosty. Me chamo ${this.props.user.name} e desejo falar com o Suporte, pois não concordo com as mudanças nos termos.`)}
          >
            Não
          </div>
        </div>
      </div>
    )
  }

  renderPopup = () => {
    return (
      <Popup
        open={this.state.showPopup}
        position='right center'
        contentStyle={styles.popupContentStyle}
        overlayStyle={styles.popupOverlayStyle}
        closeOnDocumentClick={false}
      >
        <div className='modal'
        >
          {this.state.loading ? this.renderLoader() : this.renderPopupContent() }
        </div>
      </Popup>
    )
  }

  render () {
    return (
      <React.Fragment>
        {this.props.children}
        {this.state.showPopup && this.renderPopup()}
      </React.Fragment>
    )
  }
}

const mapSateToProps = state => ({
  token: state.userReducer.token,
  user: state.userReducer.user
})

export default connect(
  mapSateToProps,
  actions
)(TermsHandler)



// WEBPACK FOOTER //
// ./src/services/TermsHandlers.js